import { FormComponentProps } from 'components/shared/CRUD/TableCRUDLayout';
import DrawerFormSkeleton from 'components/shared/CRUD/components/DrawerFormSkeleton';

import { useGetClusterRowData } from '../hooks/useGetClusterRowData';
import ClusterForm from './ClusterForm';

const CreateEditForm = ({ rowId, handleClose }: FormComponentProps) => {
  const { isFetching, data } = useGetClusterRowData(rowId);

  return isFetching ? (
    <DrawerFormSkeleton count={1} />
  ) : (
    <ClusterForm currentData={data} handleClose={handleClose} />
  );
};

export default CreateEditForm;
